import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { Observable, map, of } from 'rxjs';
import { AppDialogService } from '../services/app-dialog.service';

export interface HasUnsavedChanges {
  hasUnsavedChanges: () => boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DisableBackGuard implements CanDeactivate<HasUnsavedChanges> {
  private modalService = inject(AppDialogService);

  canDeactivate(component: HasUnsavedChanges): Observable<boolean> {
    if (component.hasUnsavedChanges()) {
      return this.modalService
        .open<ConfirmationDialogComponent, never, boolean>(
          ConfirmationDialogComponent,
        )
        .closed.pipe(map((confirmed) => confirmed === true));
    } else {
      return of(true);
    }
  }
}
